import React from 'react';
import Button from '../../../../../../styled/Button';
import { Column, Columns } from '../../../../../../styled/Columns/wrappers';

interface IFooter {
  usedFiltersCount: number;
  resetRegularFilters: () => void;
  toggleShowPanel: () => void;
  count: number;
}

export default function Footer({
  usedFiltersCount,
  resetRegularFilters,
  toggleShowPanel,
  count,
}: IFooter) {
  return (
    <>
      <Columns className="space-1 valign-middle">
        {usedFiltersCount > 0 && (
          <Column className="grow">
            <Button rounded full tone="soft" onClick={resetRegularFilters}>
              Rensa filter
            </Button>
          </Column>
        )}
        <Column className="grow">
          <Button onClick={toggleShowPanel} title={`Visa ${count} produkter`} rounded full>
            {`Visa ${count} produkter`}
          </Button>
        </Column>
      </Columns>
    </>
  );
}
